if ( window.wp && window.wp.ajax ) {
    const { registerBlockType } = window.wp.blocks;

    const { 
        InspectorControls,
        InnerBlocks
    } = window.wp.editor;

    const { 
        PanelBody, 
        TextControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/nav-tabs', {
        // built-in attributes
        title: 'Nav Tabs',
        description: 'Nav Tabs',
        icon: 'slides',
        category: 'custom-tabs',
        example: {},

        // custom attributes
        attributes: {
            id: {
                type: 'string',
                default: '',
            },
        },

        edit ({ attributes, setAttributes }) {

            const {
                id,
            } = attributes;

            function onIdChange (id) {
                setAttributes({id: id});
            };

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Tab settings' }>
                        <p><strong>ID must be unique</strong></p>
                        <TextControl value={ id } onChange={ onIdChange }></TextControl>
                    </PanelBody>
                </InspectorControls>,
                <nav>
                    <div class="nav nav-tabs" id={ "nav-tab-" + id } role="tablist">
                        <InnerBlocks allowedBlocks={ [ 'custom-gutenberg/tab-button' ] } template={ [ [ 'custom-gutenberg/tab-button', {} ] ] } />
                    </div>
                </nav>
            ]);
        },

        save ({ attributes }) {

            const {
                id,
            } = attributes;

            return ( 
                <nav>
                    <div class="nav nav-tabs" id={ "nav-tab-" + id } role="tablist">
                        <InnerBlocks.Content />
                    </div>
                </nav>
            );
        },
    });
}